import React from 'react';
import Helmet from 'react-helmet';
import * as styles from './QueueItemEditBar.scss';

function QueueItemEditBar(props) {
  var handleEdit = props.handleEdit,
      organization = props.organization,
      deletePost = props.deletePost;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.editBar
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(styles.editBarIcon, " icon ion-edit"),
    onClick: function onClick() {
      handleEdit();
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(styles.editBarIcon, " icon ion-ios-trash-outline"),
    onClick: function onClick() {
      deletePost();
    },
    style: {
      fontSize: 28
    }
  }));
}

export default QueueItemEditBar;